import * as React from 'react';
import { Image as AntdImage, Button } from 'antd';
import { CheckOutlined, EyeFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PictureModel from '../../../../model/picture/PictureModel';
import { observer } from 'mobx-react-lite';
import UploadedPicture from '../../../../model/picture/UploadedPicture';
import StockPicture from '../../../../model/picture/StockPicture';
import AntdCustomButton from '../../../../../../components/buttons/AntdCustomButton';

interface FCProps {
  src: string;
  type: 'uploaded' | 'stock';
  mediaId: string;
}

const Image: React.FC<FCProps> = observer(({ src, type, mediaId }) => {
  const [visible, setVisible] = React.useState(false);
  const { t } = useTranslation();

  if (PictureModel.selectedPicture?.getUrl() === src) {
    return (
      <div className="relative w-[calc(50%-0.3rem)] box-border border-solid border-[1px] border-[#00000026]">
        <AntdImage width={'100%'} height={200} src={src} preview={false} className="object-cover object-center" />
        <div className="absolute top-0 left-0 w-[100%] h-[100%] bg-[white] opacity-85 flex justify-center items-center">
          <CheckOutlined className="text-4xl" />
        </div>
      </div>
    );
  }

  return (
    <div className="w-[calc(50%-0.3rem)] box-border border-solid border-[1px] border-[#00000026]">
      <AntdImage
        width={'100%'}
        height={200}
        className="object-cover object-center"
        preview={{
          visible: visible,
          onVisibleChange: (visible) => setVisible(visible),
          mask: (
            <div className="flex flex-col gap-2">
              <AntdCustomButton
                icon={<EyeFilled />}
                appearance="important"
                onClick={() => {
                  setVisible(true);
                }}>
                {t('view image')}
              </AntdCustomButton>
              <AntdCustomButton
                icon={<CheckOutlined />}
                appearance="important"
                onClick={(e) => {
                  e.stopPropagation();

                  if (type === 'uploaded') {
                    PictureModel.selectPicture(new UploadedPicture(src));
                  }

                  if (type === 'stock') {
                    PictureModel.selectPicture(new StockPicture(src, mediaId));
                  }
                }}>
                {t('use image')}
              </AntdCustomButton>
            </div>
          )
        }}
        src={src}
      />
    </div>
  );
});

export default Image;
